module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBrowse),
      expression: "showBrowse"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMediaManager = true
      }
    }
  }, [_vm._v("\n    Wybierz\n  ")]), _vm._v(" "), _c('media-manager', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMediaManager),
      expression: "showMediaManager"
    }],
    attrs: {
      "selected": _vm.localValue
    },
    on: {
      "close": function($event) {
        _vm.showMediaManager = false
      },
      "select": _vm.onSelect,
      "unselect": _vm.onUnSelect
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMediaManager),
      expression: "!showMediaManager"
    }],
    staticClass: "row"
  }, _vm._l((_vm.localValue), function(media, index) {
    return _c('media-item', {
      key: index,
      attrs: {
        "media": media
      },
      on: {
        "change": function($event) {
          _vm.showMediaManager = true
        },
        "delete": _vm.onDelete
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96b73b16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaInput.vue
// module id = 464
// module chunks = 1